import axios from 'axios'

// 让请求在浏览器中允许跨域携带cookie
// axios.defaults.withCredentials = true

// 使用自定义配置新建一个 axios 实例

const service = axios.create({
    // 基础的请求地址
    // baseURL: 'http://192.168.10.80:8091/',
    // baseURL: '/dev',
    baseURL: 'https://bj.gongbocoins.com/search-api/shoucq-api/',
    timeout: 10000 // 请求超时时间 1000ms = 1s，更改为10s
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在请求发送之前做一些处理
        config.headers['lang'] = localStorage.getItem('language') || ((navigator.language == 'zh-CN' || navigator.language == 'en') ? navigator.language : 'zh-CN')
        return config;
    },
    error => {
        // 发送失败
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data;
        // 这个状态码是和后端约定的
        const { code } = dataAxios;
        return dataAxios;
    },
    error => {

    }
);

export default service;


// WEBPACK FOOTER //
// ./src/api/xy.js